module.exports = __webpack_public_path__ + "__static/site-1768578553954/img/top-img.12703c9d.png";